
import { useState } from 'react';
import Menu from './menu';

export default function Header({ settings }) {
    const { mainColor, logo } =  settings 
    const [hoveredMenu, setHoveredMenu] = useState(""); // State for hover
    const [mobileOpenMenu, setMobileOpenMenu] = useState(""); // State for hover
    const [hamburgerOpen, setHamburgerOpen] = useState(false);

    return (
        <div>
            <div className='w-full drop-shadow-xl fixed z-50 overflow-y-scroll overflow-x-hidden no-scrollbarw lg:overflow-y-visible lg:overflow-x-visible lg:no-scrollbarw lg:h-auto' style={{ height: hamburgerOpen ? "100%" : "" }}  >
                <div className="bg-white flex justify-center" onMouseLeave={() => setHoveredMenu("")} >
                    <div className="container flex w-full justify-between" >
                        <div><a href="/home">{logo.asset && <img src={logo.asset.url} className='h-14 mt-3 mb-3' />}</a></div>
                        <div><Menu
                            hoveredMenu={hoveredMenu}
                            setHoveredMenu={setHoveredMenu}
                            mobileOpenMenu={mobileOpenMenu}
                            setMobileOpenMenu={setMobileOpenMenu}
                            hamburgerOpen={hamburgerOpen}
                            setHamburgerOpen={setHamburgerOpen}
                            settings={settings}
                        /></div>
                    </div>
                </div>
            </div>
            <div className="h-20"></div>
        </div>
    );
}
